import React, { useState, useEffect } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { useConfiguration } from '../../../context/configurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { isOriginInUse } from '../../../util/search';
import { FormattedMessage } from '../../../util/reactIntl';
import { Form, PrimaryButton } from '../../../components';

import FilterCategories from '../Primitives/SearchCTA/FilterCategories/FilterCategories';
import FilterLocation from '../Primitives/SearchCTA/FilterLocation/FilterLocation';

import css from './SearchPopupModal.module.css';

const SearchPopupModal = ({ isOpen, onClose, defaultCategory }) => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const [submitDisabled, setSubmitDisabled] = useState(false);

  // Lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Close on Escape key
  useEffect(() => {
    const handleKeyUp = e => {
      if (e.key === 'Escape' && isOpen) onClose();
    };
    window.addEventListener('keyup', handleKeyUp);
    return () => window.removeEventListener('keyup', handleKeyUp);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const categories = config.categoryConfiguration?.categories || [];

  const initialValues = defaultCategory ? { pub_categoryLevel1: defaultCategory } : {};

  const onSubmit = values => {
    let queryParams = {};

    if (values.pub_categoryLevel1) {
      queryParams.pub_categoryLevel1 = values.pub_categoryLevel1;
    }

    if (values.location?.selectedPlace) {
      const {
        search,
        selectedPlace: { origin, bounds },
      } = values.location;
      queryParams.bounds = bounds;
      queryParams.address = search;

      if (isOriginInUse(config) && origin) {
        queryParams.origin = `${origin.lat},${origin.lng}`;
      }
    }

    const to = createResourceLocatorString('SearchPage', routeConfiguration, {}, queryParams);
    onClose();
    history.push(to);
  };

  return (
    <div className={css.backdrop} onClick={onClose} role="presentation">
      <div
        className={css.popup}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Search"
      >
        <FinalForm
          onSubmit={onSubmit}
          initialValues={initialValues}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit} className={css.form}>
              <div className={css.fieldWrap}>
                <FilterCategories
                  categories={categories}
                  alignLeft={true}
                  rootClassName={css.categoryRoot}
                />
              </div>

              <hr className={css.divider} />

              <div className={css.fieldWrap}>
                <FilterLocation
                  setSubmitDisabled={setSubmitDisabled}
                  alignLeft={true}
                  rootClassName={css.locationRoot}
                />
              </div>

              <PrimaryButton
                disabled={submitDisabled}
                type="submit"
                className={css.searchButton}
              >
                <FormattedMessage id="PageBuilder.SearchCTA.buttonLabel" />
              </PrimaryButton>
            </Form>
          )}
        />
      </div>
    </div>
  );
};

export default SearchPopupModal;
